
// src/connects/group-export-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import config from '../config'
import map from 'lodash/map'
import moment from 'moment'

export const mapStateToProps = (state)=> {
  return {
    access_token: state.sessions.access_token,
    field_list: state.templates.field_list,
    isFoldersFetching: state.googleApi.isFoldersFetching,
    isFoldersFetchFailed: state.googleApi.isFoldersFetchFailed,
    folders: state.googleApi.folders,
    isUserInfoFetching: state.googleApi.isUserInfoFetching,
    isUserInfoFetchFailed: state.googleApi.isUserInfoFetchFailed,
    userinfo: state.googleApi.userinfo,
    isUploadFetching: state.googleApi.isUploadFetching,
    isUploadFetchFailed: state.googleApi.isUploadFetchFailed,
    refresh_token: state.googleApi.refresh_token,
    isRefreshTokenFetching: state.googleApi.isRefreshTokenFetching,
    isRefreshTokenFailed: state.googleApi.isRefreshTokenFailed,
    scheduled_settings: state.groups.scheduled_settings,
    isScheduledSettingsFetching: state.groups.isScheduledSettingsFetching,
    isScheduledSettingsFailed: state.groups.isScheduledSettingsFailed,
    isUpdateScheduledSettingsFetching: state.groups.isUpdateScheduledSettingsFetching,
    isUpdateScheduledSettingsFailed: state.groups.isUpdateScheduledSettingsFailed,
    currentUser: state.user.current,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      if(props.user && props.group){
        dispatch(actions.fetchTemplateFields(props.group.group_id, props.user.user_id))
        props.fetchScheduledSettings(props.group.group_id)
      }
    },

    willUpdate: (props, nextProps)=> {
      if (!props.isFoldersFetchFailed && nextProps.isFoldersFetchFailed) {
        nextProps.updateUI({ gapiReady: false })
        dispatch(emitAlertMessage({ message: "label:Googleカレンダーの取得に失敗しました" }, 'error'))
      }
    },

    willUnmount: ()=> {
      dispatch(actions.clearGoogleDriveFolders())
      dispatch(actions.clearScheduledSettings())
    },

    fetchUserInfo: ()=> dispatch(actions.fetchGoogleDriveUserInfo()),

    fetchFolders: ()=> {
      dispatch(actions.fetchGoogleDriveFolders())
    },

    fetchRefreshToken: ()=> {
      dispatch(actions.fetchRefreshToken())
    },

    fetchScheduledSettings: (group_id)=> {
      dispatch(actions.fetchScheduledSettings(group_id))
    },

    updateScheduledSettings: (props)=> {
      dispatch(actions.updateScheduledSettings(props.group.group_id, props.ui.refreshToken, props.ui.isScheduled, props.ui.save_folder_id, props.ui.interval, moment(props.ui.scheduledDate).format('YYYY-MM-DD'), props.access_token))
    },

    cancelGoogleDrive: ()=> {
      dispatch(actions.clearGoogleDriveFolders())
    },

    downloadFile: (props, fields)=> {
      const file_name = 'diaries_summary.xlsx'

      let params = {
        group_id: props.group.group_id,
        start_date: moment(props.ui.startDate).format('YYYY-MM-DD'),
        end_date: moment(props.ui.endDate).format('YYYY-MM-DD'),
        access_token: props.access_token,
      }
      if (fields) params.field_names = fields.join(',')
      const createQueryString = params => Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&')
      let queryString = createQueryString(params)

      const file_url = config.baseUrl + 'v3/export/diaries_summary?' + queryString

      dispatch(actions.uploadGoogleDriveFile(props.ui.folder_id, file_name, file_url))
    },
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    groupExportUrl: (startDate, endDate, fields)=> {
      var params = {
        group_id: ownProps.group.group_id,
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        access_token: stateProps.access_token,
      }
      if (fields) params.field_names = fields.join(',')
      return `${config.baseUrl}v3/export/diaries?${map(params, (value, key)=> `${key}=${encodeURI(value)}`).join('&')}`
    }
  })
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: {
    startDate: moment().startOf('month'),
    endDate: moment(),
    folder_id: 'undefined',
    save_folder_id: (props)=> (props.scheduled_settings && props.scheduled_settings.folder_id) ? props.scheduled_settings.folder_id : 'undefined',
    scheduledDate: (props)=> (props.scheduled_settings && props.scheduled_settings.generate_next_at) ? moment(props.scheduled_settings.generate_next_at) : moment(),
    interval: (props)=> (props.scheduled_settings && props.scheduled_settings.interval) ? props.scheduled_settings.interval : 'week',
    isScheduled: (props)=> (props.scheduled_settings && props.scheduled_settings.is_active) ? props.scheduled_settings.is_active : false,
    refreshToken: (props)=> (props.scheduled_settings && props.scheduled_settings.refresh_token) ? props.scheduled_settings.refresh_token : '',
    gapiReady: false,
  }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/group-export-panel.js